import React, { useEffect, useState } from "react";
import { useSelectedContextState } from "../context/selectedContext";
import { StyledTable } from "../styles/styledComponents";
import ResultValue from "../types/ResultValue";
import { useTranslation } from "react-i18next";
import { formatWeight, formatNumber, detectBestLocale } from '../utils/utils';

type ResultTableProps = {
  results?: ResultValue[];
  total?: ResultValue,
  discount?: number
  productName?:string,
  fieldSummary?:string,
  countryCode?: string,
  fileName?: string,
};

const ResultTable = (props: ResultTableProps) => {
  const { results, total, discount } = props;
  const [tableResult, setTableResult] = useState<ResultValue[]>([]);
  const [state] = useSelectedContextState();
  const { clearAll } = state;
  const { t } = useTranslation("trans");
  const locale = detectBestLocale();
  useEffect(() => {

    if (results)
      setTableResult(results);

  }, [results]);

  useEffect(() => {
    if (clearAll) {
      setTableResult([]);
    }
  }, [clearAll]);

  if (total == null) return null;

  return (
    <div style={{ width: '100%', overflow: 'auto' }}>
      <StyledTable>
        <thead>
          <tr>
            <th>{t("table.artNr").toUpperCase()}</th>
            <th>{t("table.term").toUpperCase()}</th>
            <th>{t("table.qty").toUpperCase()}</th>
            <th className={"right-align"}>{t("table.weight").toUpperCase()}</th>
            <th>{t("table.price/art").toUpperCase()}</th>
            <th>{t("table.discount").toUpperCase()}</th>
            <th>{t("table.net_price").toUpperCase()}</th>
          </tr>
        </thead>
        <tbody>
          {tableResult?.map((item, index) => (
            <tr key={index}>
              <td><span>{item.code}</span></td>
              <td>{item.name}</td>
              <td style={{ textAlign: 'center' }}>{item.amount}</td>
              <td className={"right-align"}>{formatWeight(item.weight, locale, false, 1)}</td>
              <td className={"right-align"}>{formatNumber(item.price, locale, 0)}</td>
              <td className={"right-align"}>{discount}</td>
              {/*<td><NumberFormat value={item.netPrice != null ? item.netPrice: "0"} displayType={'text'} decimalScale={2} decimalSeparator={','} thousandSeparator={false} fixedDecimalScale={true} /></td>*/}
              <td className={"right-align"}>{formatNumber(item.netPrice, locale, 0)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th scope="row" colSpan={1}>
              {t("table.total").toUpperCase()}
            </th>
            <td colSpan={2}>{t("table.description")}</td>
            {/*<td colSpan={1}><NumberFormat value={total.weight != null ? total.weight : "0"} displayType={'text'} decimalScale={2} decimalSeparator={','} thousandSeparator={false} fixedDecimalScale={true} />&nbsp;KG</td>*/}
            <td colSpan={1} className={"right-align"}>{formatWeight(total.weight, locale, true, 1)}</td>
            <td colSpan={1}>&nbsp;</td>
            <td colSpan={1}>&nbsp;</td>            
      {/*<td colSpan={1}><NumberFormat value={total.netPrice != null ? total.netPrice : "0"} displayType={'text'} decimalScale={2} decimalSeparator={','} thousandSeparator={false} fixedDecimalScale={true} /></td>*/}
            <td colSpan={1} className={"right-align"}>{formatNumber(total.netPrice, locale, 0)}</td>
          </tr>
        </tfoot>
      </StyledTable>
    </div>
  );
};

export type { ResultTableProps };
export default ResultTable;
